class RegraValidacaoController extends AbstractController
  @$inject = ['$injector', 'pathService', 'regraValidacaoService']

  constructor: ($injector, pathService, @regraValidacaoService) ->
    super($injector)

    url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/regra-validacao/'
    @modalRegraValidacao = @openPopup(url + 'modal.html', 'regraValidacaoModalController as ctrl', null, 'static')
    @loadingTracker = @promiseTracker()
    @list()

  list: () ->
    @loadingTracker.addPromise(
      @regraValidacaoService.getList((data) =>
        @listOfRegraValidacao = data.data.items
      )
    )

  abrirModel: (regraValidacao) ->
    @modalRegraValidacao({
      regraValidacao: ->
        angular.copy regraValidacao
    }, (result) =>
      @list())

  adicionar: () ->
    @abrirModel({})

  editar: (regraValidacao) ->
    @abrirModel(regraValidacao)

  remover: (regraValidacao) ->
    @Confirm.warning("Atenção!",
      "Deseja realmente remover a Regra de Validação <strong>#{regraValidacao.descricao}</strong>? Essa ação não poderá ser desfeita.", {
        'Sim': =>
          @regraValidacaoService.delete(regraValidacao.id, =>
            Alert.success("Regra de validação <strong>#{regraValidacao.descricao}</strong> removida com sucesso.")
            @list()
          )
        'Não': null
      })

angular.module("eficienciaFiscalModule").controller('regraValidacaoController', RegraValidacaoController)

class RegraValidacaoModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'regraValidacaoService', 'eflService', 'regraValidacao']

  constructor: ($injector, @modalInstance, @regraValidacaoService, @eflService, regraValidacao) ->
    super($injector)

    @submitTracker  = @promiseTracker()
    @regraValidacao = regraValidacao


  testarRegra: (texto = "") ->
    @eflService.test(regra: @regraValidacao.regraExpressao, itens: texto.split("\n"), (result) =>
      @regraValidacaoTestResult = result
    )

  salvar: (form, data) ->
    data = angular.copy(data)
    if form.$valid
      @submitTracker.addPromise(
        @regraValidacaoService.save(data, (result) =>
          if result.success
            @alertSuccess(data, 'adicionada')
        )
      ) unless data.id
      @submitTracker.addPromise(
        @regraValidacaoService.save(data, (result) =>
          @alertSuccess(data, 'atualizada')
        )
      ) if data.id

  alertSuccess: (data, message) ->
    @Alert.success("Regra de validação <strong>#{data.descricao}</strong> #{message}.", 'Sucesso')
    @modalInstance.close()

angular.module("eficienciaFiscalModule").controller('regraValidacaoModalController', RegraValidacaoModalController)